import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import { Modal, Button } from "react-bootstrap";
const initialDocumentValues = {
  documentName: "",
  imageName: "",
  imageFile: null,
  imageSrc: "",
};
export default function DocumentModal2({
  visible,
  onClose,
  serviceTaskId,
  clientId,
  folderId,
  headerconfig,
}) {
  const [documentValues, setDocumentValues] = useState(initialDocumentValues);
  const [btnSubmit, setBtnSubmit] = useState(true);
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  const [errors, setErrors] = useState({});
  const [userCompanyId, setUserCompanyId] = useState("");
  const userId = localStorage.getItem("userId");

  const handleDocumentInputChange = (e) => {
    const { name, value } = e.target;
    setDocumentValues({
      ...documentValues,
      [name]: value,
    });
  };

  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      let imageFile = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (x) => {
        setDocumentValues({
          ...documentValues,
          imageFile,
          imageSrc: x.target.result,
        });
      };
      reader.readAsDataURL(imageFile);
    } else {
      setDocumentValues({
        ...documentValues,
        imageFile: null,
        imageSrc: "",
      });
    }
  };

  const validate = () => {
    let temp = {};
    temp.documentName = documentValues.documentName.trim() !== "";
    temp.imageFile = documentValues.imageFile !== null;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const resetDocumentForm = () => {
    setDocumentValues(initialDocumentValues);
  };

  const handleDocumentSubmit = (e) => {
    e.preventDefault();
    setIsSubmitClicked(true);
    if (validate()) {
      setBtnSubmit(false);
      const formData = new FormData();
      formData.append("documentName", documentValues.documentName);
      formData.append("serviceTaskId", serviceTaskId);
      formData.append("clientId", clientId);
      formData.append("imageFile", documentValues.imageFile);
      formData.append("imageName", documentValues.imageName);
      formData.append("imageSrc", documentValues.imageSrc);
      formData.append("folderId", folderId);
      formData.append("companyId", userCompanyId);

      applicationAPI()
        .createDocument(formData)
        .then(() => {
          handleSuccess("Document Uploaded");
          setBtnSubmit(true);
          onClose();
          resetDocumentForm();
        })
        .catch(() => {
          handleError("Error in uploading document");
          setBtnSubmit(true);
        });
    }
  };

  const applicationAPI = () => {
    return {
      createDocument: (formData) =>
        axios.post(config.APIACTIVATEURL + config.CREATEDOCUMENT, formData, {
          ...headerconfig,
        }),
    };
  };
  const GetUserData = () => {
    axios
      .get(config.APIACTIVATEURL + config.GETUSERBYID + "/" + userId, {
        ...headerconfig,
      })
      .then((res) => {
        if (res.data.statusCode === 200) {
          setUserCompanyId(res.data.data.companyId);
        }
      });
  };
  const applyErrorClass = (field) =>
    field in errors && !errors[field] ? " form-control-danger" : "";
  useEffect(() => {
    GetUserData();
  }, []);
  return (
    <Modal show={visible} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Upload Document</Modal.Title>
      </Modal.Header>
      <form onSubmit={handleDocumentSubmit}>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Document Name</label>
            <input
              type="text"
              name="documentName"
              value={documentValues.documentName}
              onChange={handleDocumentInputChange}
              className={"form-control" + applyErrorClass("documentName")}
              placeholder="Enter Document Name"
            />
            {isSubmitClicked && !documentValues.documentName && (
              <div className="validationerror">Please enter document name</div>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label">Upload Document</label>
            <input
              className="form-control"
              type="file"
              name="imageFile"
              onChange={handleImageChange}
            />
            {isSubmitClicked && !documentValues.imageFile && (
              <div className="validationerror">Please select a document</div>
            )}
          </div>

          <div className="mb-3 d-flex justify-content-end">
            <Button type="submit" variant="primary" disabled={!btnSubmit}>
              Upload Document
            </Button>
          </div>
        </Modal.Body>
      </form>
    </Modal>
  );
}
